<template>
  <div class="store_wrapper mb-5">
    <h4 class="main_color">إضافة فرع</h4>
    <form @submit.prevent="validateForm">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 py-0">
            <!-- <upload-image-direct
              @inputChanged="uplodeImg_1"
              model="users"
              title="صورة الفرع"
              :data_src="data.image_src"
            ></upload-image-direct> -->
            <!-- End:: Image -->
          </div>
          <!-- Start:: Image -->

          <!-- Start:: Name -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                v-model.trim="data.full_name"
              />
              <label for="name_input" class="form-label">
                اسم مالك الفرع*
              </label>
            </div>
          </div>
          <!-- End:: Name -->

          <!-- Start:: Email -->
          <!-- <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label disabled">
              <input
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.user_name"
              />
              <label for="name_input" class="form-label"> اسم المسنخدم* </label>
            </div>
          </div> -->
          <!-- End:: Email -->
          <!-- Start:: Country -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label disabled">
              <label class="form-label">
                {{ $t("forms.labels.phone_code") }}*
              </label>
              <multiselect
                :loading="!countries.length"
                v-model="data.phone_code"
                :options="countries"
                label="phone_code"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
          <!-- Start:: Country -->

          <!-- Start:: Phonecode -->
          <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.phone_code"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.phoneCode") }}*
                </label>
              </div>
            </div> -->
          <!-- End:: Phonecode -->

          <!-- Start:: Phone -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.phone"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.phone") }}*
              </label>
            </div>
          </div>
          <!-- End:: Phone -->

          <!-- <div class="col-lg-6 p-0"></div> -->
          <!-- Start:: Country -->
          <!-- <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label">
                {{ $t("forms.labels.country") }}*
              </label>
              <multiselect
                :loading="!countries.length"
                v-model="data.country"
                :options="countries"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
              ></multiselect>
            </div>
          </div> -->
          <!-- Start:: Country -->

          <!-- Start:: Cities -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label"> {{ $t("forms.labels.city") }}* </label>
              <multiselect
                v-model="data.city"
                :options="cities"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                @input="
                  getDistricts(data.city?.id);
                  data.primary_district = null;
                  data.districts = [];
                "
              ></multiselect>
            </div>
          </div>
          <!-- Start:: Cities -->

          <!-- Start:: Covered Districts (district_ids multi-select) -->
          <div class="col-lg-6 py-0">
            <div
              class="input_wrapper top_label"
              :class="{ disabled: !data.city }"
            >
              <label class="form-label">
                {{ $t("forms.labels.districts") }}
              </label>
              <multiselect
                v-model="data.districts"
                :options="districts"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
                :multiple="true"
                @input="
                  if (
                    data.primary_district &&
                    !data.districts.some(
                      (d) => d.id === data.primary_district.id
                    )
                  ) {
                    data.primary_district = null;
                  }
                "
              ></multiselect>
              <div
                v-if="data.districts && data.districts.length"
                class="selected-districts-prices mt-2"
              >
                <span
                  v-for="d in data.districts"
                  :key="d.id"
                  class="badge badge-light mr-1 mb-1"
                >
                  {{ d.name }}
                  <template
                    v-if="
                      d.delivery_price !== undefined &&
                      d.delivery_price !== null
                    "
                  >
                    — {{ d.delivery_price }}
                  </template>
                </span>
              </div>
            </div>
          </div>
          <!-- End:: Covered Districts -->

          <!-- Start:: Primary District -->
          <div class="col-lg-6 py-0">
            <div
              class="input_wrapper top_label"
              :class="{ disabled: !data.districts || !data.districts.length }"
            >
              <label class="form-label">
                {{ $t("forms.labels.primary_district") }}*
              </label>
              <multiselect
                v-model="data.primary_district"
                :options="data.districts"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                :disabled="!data.districts || !data.districts.length"
              ></multiselect>
              <small class="form-text text-muted">
                {{ $t("forms.labels.primary_district_helper") }}
              </small>
            </div>
          </div>
          <!-- End:: Primary District -->

          <!-- Start:: Selected Districts Map Preview -->
          <div
            class="col-12 py-0"
            v-if="data.districts && data.districts.length"
          >
            <selected-districts-map-preview
              :districts="districtsForMap"
              height="360px"
            ></selected-districts-map-preview>
          </div>
          <!-- End:: Selected Districts Map Preview -->
          <!-- End:: Covered Districts -->

          <!-- Start:: Password -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="password"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.password"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.password") }}*
              </label>
            </div>
          </div>
          <!-- End:: Password -->

          <!-- Start:: Password  Confirmation-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="password"
                class="form-control"
                v-model.trim="data.password_confirmation"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.confirmPassword") }}*
              </label>
            </div>
          </div>

          <!-- Start:: Purchase Settlement Method -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label">
                {{ $t("forms.labels.purchase_settlement_method") }}
              </label>
              <multiselect
                v-model="data.purchase_settlement_method"
                :options="purchaseSettlementMethods"
                label="name"
                track-by="value"
                placeholder=" "
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
          <!-- End:: Purchase Settlement Method -->

          <!-- Start:: has_on_demand_rider & delivery cost options -->
          <div class="col-12 py-0">
            <v-checkbox
              :label="$t('forms.labels.has_on_demand_rider')"
              v-model="data.has_on_demand_rider"
              color="#783D73"
            ></v-checkbox>

            <div class="row mr-3" v-if="data.has_on_demand_rider">
              <div class="col-md-6 py-0">
                <v-checkbox
                  :label="$t('forms.labels.delivery_cost_on_client')"
                  v-model="data.delivery_cost_on_client"
                  color="#783D73"
                ></v-checkbox>
              </div>
              <div class="col-md-6 py-0">
                <v-checkbox
                  :label="$t('forms.labels.delivery_cost_on_store')"
                  v-model="data.delivery_cost_on_store"
                  color="#783D73"
                ></v-checkbox>
              </div>
            </div>
          </div>
          <!-- End:: has_on_demand_rider -->

          <!-- Start:: base_fire_price-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.base_fire_price"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.base_fire_price") }}
              </label>
            </div>
          </div>
          <!-- End:: base_fire_price-->

          <!-- Start:: price_km-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.price_km"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.price_km") }}
              </label>
            </div>
          </div>
          <!-- End:: price_km-->

          <!-- Start:: base_delivery_price-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.base_fire_km"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.base_fire_km") }}
              </label>
            </div>
          </div>
          <!-- End:: base_fire_km-->

          <!-- Start:: service_fee-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.service_fee"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.service_fee") }}
              </label>
            </div>
          </div>
          <!-- End:: service_fee-->

          <!-- Start:: service_fee_female-->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                v-model.trim="data.service_fee_female"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.service_fee_female") }}
              </label>
            </div>
          </div>
          <!-- End:: service_fee_female-->

          <!-- START:: MAP -->
          <div class="col-12 fadeIn">
            <div class="large-map">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  id="autocomplete_ar"
                  placeholder="ابحث على الخريطة"
                  @click="getAddressAr"
                />
              </div>
              <GmapMap
                :center="coordinates_to_edit"
                :zoom="7"
                :draggable="true"
                map-type-id="terrain"
              >
                <GmapMarker
                  :position="coordinates_to_edit"
                  :clickable="true"
                  :draggable="true"
                  @dragend="updateMarker($event.latLng)"
                />
                />
              </GmapMap>
            </div>
            <div class="col-lg-12 py-0 mt-5">
              <div class="input_wrapper top_label">
                <textarea
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.location"
                />
                <label for="name_input" class="form-label"> وصف الموقع </label>
              </div>
            </div>

            <!-- Start:: Is Active -->
            <!-- <div class="col-12 py-0">
                <v-checkbox
                  :label="$t('forms.labels.is_active')"
                  v-model="data.is_active"
                  color="success"
                ></v-checkbox>
              </div> -->
            <!-- End:: Is Active -->
          </div>
          <!-- END:: MAP -->
        </div>
      </div>

      <div class="buttons_wrapper">
        <button class="button_style_1" :disabled="btnIsLoading">
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ["id", "clear_fileds"],
  data() {
    return {
      branch: JSON.parse(localStorage.getItem("zoz_store_branch")),
      data: {
        full_name: null,
        user_name: null,
        phone_code: null,
        phone: null,
        country: null,
        city: null,
        primary_district: null,
        districts: [],
        password: null,
        image: null,
        location: null,
        image_src: null,
        purchase_settlement_method: null,
        has_on_demand_rider: null,
        delivery_cost_on_client: false,
        delivery_cost_on_store: false,
        base_fire_price: null,
        price_km: null,
        base_fire_km: null,
        service_fee: null,
        service_fee_female: null,
      },
      center: {
        lat: null,
        lng: null,
      },

      markers: null,
      coordinates_to_edit: { lat: 0, lng: 0 },
      countries: [],
      cities: [],
      districts: [],
      // Assigned district ids/primary read from the branch details, reconciled
      // against the city's district list (with encoded_polygon) once it loads
      // — see getData() and getDistricts().
      pendingAssignedDistrictIds: [],
      pendingPrimaryDistrictId: null,
      // ========== Loading
      btnIsLoading: false,
    };
  },
  watch: {
    "data.country"(value) {
      if (value) {
        this.getCities(value.id);
      }
    },
    clear_fileds() {
      this.data = {
        full_name: null,
        user_name: null,
        phone_code: null,
        phone: null,
        country: null,
        city: null,
        primary_district: null,
        districts: [],
        password: null,
        image: null,
        location: null,
      };
      this.center = {
        lat: null,
        lng: null,
      };
      this.markers = null;
      this.districts = [];
      this.coordinates_to_edit = { lat: 0, lng: 0 };
    },
  },
  computed: {
    purchaseSettlementMethods() {
      return [
        {
          value: "CREDIT",
          name: this.$t("forms.labels.purchase_settlement_credit"),
        },
        {
          value: "CASH_ON_PICKUP",
          name: this.$t("forms.labels.purchase_settlement_cash_on_pickup"),
        },
      ];
    },
    // Feeds <selected-districts-map-preview>: the selected covered districts
    // plus which one is the primary district, for drawing their boundaries.
    districtsForMap() {
      return (this.data.districts || []).map((d) => ({
        id: d.id,
        encoded_polygon: d.encoded_polygon,
        is_primary: !!(
          this.data.primary_district && this.data.primary_district.id === d.id
        ),
      }));
    },
  },
  methods: {
    updateCoordinates(location) {
      console.log(location);
      this.updateData = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    clickMethod(m) {
      this.center = m.position;
    },
    // END:: UPDATE LOCATION
    updateMarker(location) {
      this.coordinates_to_edit = {
        lat: location.lat(),
        lng: location.lng(),
      };

      // this.henlo = location.lat();
    },
    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.$axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});

          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;

          this.coordinates_to_edit.lat = this.center.lat;
          this.coordinates_to_edit.lng = this.center.lng;
        });
      }
    },
    getData() {
      console.log(this.branch);
      this.data.full_name = this.branch.full_name;
      this.data.image_src = this.branch.avatar;
      this.data.location = this.branch.location;
      this.data.user_name = this.branch.user_name;
      this.data.phone = this.branch.phone;
      const savedSettlementMethod =
        this.branch?.purchase_settlement_method ||
        this.branch?.store?.purchase_settlement_method ||
        "CREDIT";
      this.data.purchase_settlement_method =
        this.purchaseSettlementMethods.find(
          (m) => m.value === savedSettlementMethod
        ) || this.purchaseSettlementMethods[0];
      this.data.has_on_demand_rider = Boolean(
        this.branch?.store?.has_on_demand_rider
      );
      this.data.delivery_cost_on_client = Boolean(
        this.branch?.store?.delivery_cost_on_client
      );
      this.data.delivery_cost_on_store = Boolean(
        this.branch?.store?.delivery_cost_on_store
      );
      this.data.base_fire_price = this.branch?.store?.base_fire_price;
      this.data.price_km = this.branch?.store?.price_km;
      this.data.base_fire_km = this.branch?.store?.base_fire_km;
      this.data.service_fee = this.branch?.store?.service_fee;
      this.data.service_fee_female = this.branch?.store?.service_fee_female;
      this.data.phone_code = this.countries.find(
        (el) => el.phone_code == this.branch.phone_code
      );
      const assignedDistricts =
        this.branch.districts || this.branch.store?.districts || [];
      if (Array.isArray(assignedDistricts) && assignedDistricts.length > 0) {
        // Minimal objects for immediate display; getDistricts() swaps these
        // for the full objects (incl. encoded_polygon) once the city's
        // district list resolves below.
        this.data.districts = assignedDistricts.map((d) => ({
          id: d.id,
          name: d.name || (d.ar ? d.ar.name : `${d.id}`),
          delivery_price: d.delivery_price,
        }));
        this.pendingAssignedDistrictIds = assignedDistricts.map((d) => d.id);

        const primaryFromList = assignedDistricts.find((d) => d.is_primary);
        this.pendingPrimaryDistrictId =
          (primaryFromList && primaryFromList.id) ||
          this.branch.primary_district_id ||
          this.branch.store?.primary_district_id ||
          null;
        if (primaryFromList) {
          this.data.primary_district = {
            id: primaryFromList.id,
            name:
              primaryFromList.name ||
              (primaryFromList.ar
                ? primaryFromList.ar.name
                : `${primaryFromList.id}`),
          };
        }
      }
      if (this.branch.city) {
        this.data.city = {
          id: this.branch.city.id,
          name: `${this.branch.city.name}`,
        };
        this.getDistricts(this.branch.city.id);
      }
      this.coordinates_to_edit = {
        lat: +this.branch.lat,
        lng: +this.branch.lng,
      };
    },

    // START:: G-MAP GET ADDRESS
    getAddressAr() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          place.geometry.location.lat();
          place.geometry.location.lng();
          place.formatted_address;
          // self.data.address = place.formatted_address;
          // console.log();
          self.coordinates_to_edit = {
            lat: Number(place.geometry.location.lat()),
            lng: Number(place.geometry.location.lng()),
          };
          // self.markers[0].position.lat = place.geometry.location.lat();
          // self.markers[0].position.lng = place.geometry.location.lat();
        });
      });
    },
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.image = obj;
    },
    // ============ Get Select Lists Data
    async getCountries() {
      await this.$axios({
        method: "GET",
        url: `country_not_paginated`,
      })
        .then((res) => {
          this.countries = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
              phone_code: item.phone_code,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    async getCities() {
      await this.$axios({
        method: "GET",
        url: `city_not_paginated`,
      })
        .then((res) => {
          this.cities = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getDistricts(cityId) {
      if (!cityId) {
        this.districts = [];
        return;
      }
      this.$axios({
        method: "GET",
        url: `${process.env.VUE_APP_BASE_URL_GENERAL}/district/${cityId}`,
      })
        .then((res) => {
          this.districts = (res.data.data || [])
            .filter((item) => !!item.is_active)
            .map((item) => {
              return {
                id: item.id,
                name: `${item.name}`,
                delivery_price: item.delivery_price,
                encoded_polygon: item.encoded_polygon,
              };
            });

          // Reconcile the branch's already-assigned districts (loaded in
          // getData(), before the city's district list was available) with
          // the full district objects (which now carry encoded_polygon) so
          // the map preview and dropdowns show the correct pre-selection.
          if (
            this.pendingAssignedDistrictIds &&
            this.pendingAssignedDistrictIds.length
          ) {
            this.data.districts = this.districts.filter((d) =>
              this.pendingAssignedDistrictIds.includes(d.id)
            );
            if (this.pendingPrimaryDistrictId) {
              this.data.primary_district =
                this.districts.find(
                  (d) => d.id === this.pendingPrimaryDistrictId
                ) || null;
            }
            this.pendingAssignedDistrictIds = [];
            this.pendingPrimaryDistrictId = null;
          }
        })
        .catch((error) => {
          console.log(error.response?.data?.message);
        });
    },

    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.full_name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      }
      // else if (!this.data.user_name) {
      //   this.$iziToast.error({
      //     timeout: 2000,
      //     message: "اسم المستخدم مطلوب",
      //     position: "bottomRight",
      //   });
      //   this.btnIsLoading = false;
      //   return;
      // }
      else if (!this.data.phone_code) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone_code"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length < 9) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اكبر من 9 ارقام",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.city) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار المدينة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.districts || this.data.districts.length === 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجى اختيار منطقة واحدة على الأقل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.primary_district) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.primary_district"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (
        this.data.password &&
        this.data.password != this.data.password_confirmation
      ) {
        this.$iziToast.error({
          timeout: 2000,
          message: "تاكيد الباسورد يجب  ان يساوي الباسورد",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location) {
        this.$iziToast.error({
          timeout: 2000,
          message: "وصف الموقع مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },
    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.image) {
        submit_data.append("image", this.data.image);
      }
      submit_data.append("full_name", this.data.full_name);
      submit_data.append("phone_code", this.data.phone_code.phone_code);
      submit_data.append("phone", this.data.phone);

      if (this.data.city) {
        submit_data.append("city_id", this.data.city.id);
      }
      if (this.data.primary_district) {
        submit_data.append(
          "primary_district_id",
          this.data.primary_district.id
        );
      }
      if (this.data.districts && this.data.districts.length > 0) {
        // Guarantee the primary district is always part of district_ids,
        // even though the primary dropdown is already restricted to the
        // selected covered districts.
        const districtIds = this.data.districts.map((d) => d.id);
        if (
          this.data.primary_district &&
          !districtIds.includes(this.data.primary_district.id)
        ) {
          districtIds.push(this.data.primary_district.id);
        }
        districtIds.forEach((id, index) => {
          submit_data.append(`district_ids[${index}]`, id);
        });
      }
      submit_data.append("user_name", this.data.user_name);
      submit_data.append("location", this.data.location);
      submit_data.append("lat", this.coordinates_to_edit.lat);
      submit_data.append("lng", this.coordinates_to_edit.lng);
      if (this.data.password) {
        submit_data.append("password", this.data.password);
      }
      if (this.data.purchase_settlement_method) {
        submit_data.append(
          "purchase_settlement_method",
          this.data.purchase_settlement_method.value
        );
      }
      submit_data.append("has_on_demand_rider", +this.data.has_on_demand_rider);
      if (this.data.has_on_demand_rider) {
        submit_data.append(
          "delivery_cost_on_client",
          +this.data.delivery_cost_on_client
        );
        submit_data.append(
          "delivery_cost_on_store",
          +this.data.delivery_cost_on_store
        );
      }
      submit_data.append(
        "base_fire_price",
        this.data.base_fire_price != null && this.data.base_fire_price !== ""
          ? this.data.base_fire_price
          : null
      );
      submit_data.append(
        "price_km",
        this.data.price_km != null && this.data.price_km !== ""
          ? this.data.price_km
          : null
      );
      submit_data.append(
        "base_fire_km",
        this.data.base_fire_km != null && this.data.base_fire_km !== ""
          ? this.data.base_fire_km
          : null
      );
      submit_data.append(
        "service_fee",
        this.data.service_fee != null && this.data.service_fee !== ""
          ? this.data.service_fee
          : null
      );
      submit_data.append(
        "service_fee_female",
        this.data.service_fee_female != null &&
          this.data.service_fee_female !== ""
          ? this.data.service_fee_female
          : null
      );
      submit_data.append("store_id", this.id);
      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `store/branch/${this.branch.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$emit("branchAdded");
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  async created() {
    //  this.getLocation();
    await this.getCountries();
    await this.getCities();
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.store_wrapper {
  padding: 1rem;
  @include mainShadow;
  border-radius: 15px;
}
</style>
